(function () {
    'use strict';

    var tracking = cylindo.getModule('tracking') || {};

    function areItemsValid(items) {
        for (var index = 0, length = items.length; index < length; index++) {
            var item = items[index];
            if (!item || !item.hasOwnProperty('sku') || !item.hasOwnProperty('quantity') || !item.hasOwnProperty('price') ||
                !item.hasOwnProperty('org_price') || !item.hasOwnProperty('features')) {
                return false;
            }
        }
        return true;
    }
    var CheckoutTracking = function (clientID) {
        var self = this;

        var network = cylindo.getModule('cylindo.core.network');
        var settings = cylindo.getModule('cylindo.core.config');
        var pubsub = cylindo.getModule('cylindo.util.pubsub').create();

        var trackingIFrameClass = '__cylindo_tracking';
        var internalSeq = 0;
        var eventQueue = [];
        var clientData = {};
        var trackingDefaultSKU = 'check$confirm';
        var trackingIFrameElem;
        this.on = pubsub.on;
        this.trigger = pubsub.trigger;
        this.off = pubsub.off;
        this.data = {
            loaded: false,
            userID: null, 
            userSessionID: null, 
            viewerContainer: null
        };

        this.clientID = clientID;

        this.get = get;
        this.destroy = destroy;
        this.track = track;

        init(clientID);
        function init(cID) {
            var domLoadingTime;
            var elapsedTime;

            if (window.performance && window.performance.timing) {
                try {
                    domLoadingTime = window.top.performance.timing.domLoading;
                }
                catch (e) {
                    domLoadingTime = window.performance.timing.domLoading;
                }
                if (!domLoadingTime || 
                    domLoadingTime < 0) {
                    domLoadingTime = Date.now();
                }
            }
            else {
                domLoadingTime = Date.now();
            }

            elapsedTime = Date.now() - domLoadingTime;

            clientData = {
                timestamp: domLoadingTime,
                elapse: elapsedTime,
                clientID: cID,
                productID: 1,
                sku: trackingDefaultSKU
            };

            renderTrackingFrame();
        }
        /**
         * Renders tracking frame by url
         * Creates a DOM element with atrributes
         * Attach events for message handling
         */
        function renderTrackingFrame() {
            var urls = settings.get('urls');
            var trackingFrameUrl = network.resolveProtocol(urls.TRACKING_PAGE) +
                '?ts=' + Date.now() + '#' + window.location.href.split(/[?#]/)[0];
            var trackingFrame = document.createElement('iframe');

            trackingFrame.className = trackingIFrameClass;
            trackingFrame.setAttribute('src', trackingFrameUrl);
            trackingFrame.setAttribute('frameborder', '0');
            trackingFrame.setAttribute('title', trackingIFrameClass);
            trackingFrame.style.width = '0';
            trackingFrame.style.height = '0';

            if (document.addEventListener) {
                window.addEventListener('message', receiveMessage, false);
            }
            else if (document.attachEvent) { 
                window.attachEvent('onmessage', receiveMessage);
            }
            docReady(function () {
                document.getElementsByTagName('body')[0].appendChild(trackingFrame);
            });
            createEvents();
        }

        function receiveMessage(event) {
            self.get();
            var regex = /(cylindev.com)|(bugtest.it)|(cylindo.com)|(localhost)|(bs-local)|(\*)/g;
            var iframeData = null;
            if (regex.test(event.origin)) {
                try {
                    iframeData = JSON.parse(event.data);
                }
                catch (e) {
                    return;
                }
                if (iframeData.hasOwnProperty('guid') && iframeData.hasOwnProperty('sid')) {
                    clientData.guid = self.data.userID = iframeData.guid;
                    clientData.sid = self.data.userSessionID = iframeData.sid;
                    self.trigger(self.events.LOADED, {});
                }
            }
        }

        /**
         * Destroy element and remove related data.
         */
        function destroy() {
            var elem = self.get();
            if (elem) {
                elem.parentElement.removeChild(elem);
            }
            trackingIFrameElem = null;
            if (pubsub && typeof pubsub.destroy === 'function') {
                pubsub.destroy();
            }
        }
        /**
         * Returns the tracking iframe element.
         * @return {DOMObject|null}
         */
        function get() {
            var tempFrameElement = null;
            if (trackingIFrameElem) {
                return trackingIFrameElem;
            }
            tempFrameElement = document.querySelectorAll('.' + trackingIFrameClass);
            if (tempFrameElement.length) {
                trackingIFrameElem = tempFrameElement[0];
            }
            return trackingIFrameElem || null;
        }

        /**
         * Tracking function to prepare the event data for saving.
         * @param {number} event 
         * @param {Object} data 
         */
        function track(event, data, cb) {
            var viewerTrackingData;
            internalSeq++;

            viewerTrackingData = {
                t: Date.now(),
                e: event,
                s: internalSeq,
                d: data,
                c: cb || null
            };

            if (!self.data.loaded) {
                eventQueue.push(viewerTrackingData);
                return;
            }

            saveEvent(viewerTrackingData);
        }

        function saveEvent(eventData) {
            var urls = settings.get('urls');
            var addURL = network.resolveProtocol(urls.TRACKING_SERVICES_BASE + 'add');
            var metadata = settings.get('metadata');
            var eventSaved;

            network.doTracking(addURL,
                function (response) {
                    if (eventData.c) {
                        eventSaved = true;
                        eventData.c(eventSaved);
                    }
                },
                {
                    type: 'POST',
                    contentType: 'text/plain',
                    data: {
                        Version: metadata.TRACKING_MSG_VERSION,
                        Guid: clientData.guid,
                        SessionID: clientData.sid,
                        ClientID: clientData.clientID,
                        ProductID: clientData.productID,
                        PageID: clientData.timestamp,
                        Elapse: eventData.t - clientData.timestamp,
                        Seq: eventData.s,
                        Sku: clientData.sku,
                        EventType: eventData.e,
                        Data: JSON.stringify(eventData.d) || {}
                    }
                },
                function () {
                    if (eventData.c) {
                        eventSaved = false;
                        eventData.c(eventSaved);
                    }
                }
            );
        }

        function onLoaded() {
            var eqLength = eventQueue.length;
            var i;

            self.data.loaded = true;
            for (i = 0; i < eqLength; i++) {
                saveEvent(eventQueue[i]);
            }
            eventQueue = [];
        }

        function createEvents() {
            self.get();
            self.on(self.events.LOADED, onLoaded);
        }
    };

    CheckoutTracking.prototype.trackingEvents = {
        CHECKOUT_CONFIRMATION: 16
    };

    CheckoutTracking.prototype.events = {
        LOADED: 'tracking.loaded'
    };

    CheckoutTracking.prototype.checkout = function (items, totalPrice, currency, cb) {
        var toBeDeprecated = 'Cylindo: checkout method has been deprecated, please consult our documentation or contact the Support team to look for alternatives.';
        if (console.warn) {
            console.warn(toBeDeprecated);
        }
        else {
            console.log(toBeDeprecated);
        }    
        if (!Array.isArray(items)) {
            items = [items];
        }

        if (items.length === 0 || !areItemsValid(items)) {
            cb();
            throw new Error("Invalid 'items' parameter. Aborting checkout");
        }

        var len = items.length;
        var data;
        var i;

        for (i = 0; i < len; i++) {
            switch (typeof items[i].features) {
                case 'string':
                    break;
                case 'object':
                    if (typeof items[i].features.push === 'function') {
                        items[i].features = items[i].features.join('*');
                    }
                    else {
                        throw new Error('The features property should be either an array or a string!');
                    }
                    break;
                default:
                    items[i].features = '*';
                    break;
            }
            items[i].features = items[i].features ? items[i].features : '*';
            items[i].features = items[i].features.toUpperCase();
        }

        data = {
            items: items,
            total_price: totalPrice,
            currency: currency
        };

        this.track(this.trackingEvents.CHECKOUT_CONFIRMATION, data, cb);
    };

    CheckoutTracking.prototype.getItem = function (sku, quantity, price, org_price, features) {
        var toBeDeprecated = 'Cylindo: getItem method has been deprecated, please consult our documentation or contact the Support team to look for alternatives.';
        if (console.warn) {
            console.warn(toBeDeprecated);
        }
        else {
            console.log(toBeDeprecated);
        }    
        return {
            sku: sku,
            quantity: quantity,
            price: price,
            org_price: org_price,
            features: features.join('*')
        };
    };

    CheckoutTracking.prototype.bindTrackingEvent = function (cID, el, type, event, getData) {
        var fn = function () {
            this.track(cID, event, getData());
        };

        if (document.addEventListener) {
            el.addEventListener(type, fn, false);
        }
        else if (document.attachEvent) {
            el.attachEvent('on' + type, fn);
        }
        else {
            el['on' + type] = fn;
        }
    };

    CheckoutTracking.prototype.bindToCheckoutButton = function (el, getData) {
        this.bindTrackingEvent(this.clientID, el, 'click', this.trackingEvents.CHECKOUT_CONFIRMATION, getData);
    };

    tracking.checkout = {};
    tracking.checkout.create = function (clientID) {
        return new CheckoutTracking(clientID);
    };

    cylindo.addModule('tracking', tracking, true);
}).call(this);